document.addEventListener("DOMContentLoaded", function () {
 const description = document.getElementById("product-description");
 const readMoreLink = document.getElementById("pdp-read-more");
 if (!description || !readMoreLink) return;
 function checkOverflow(el) {
   return el.scrollHeight > el.clientHeight;
 }
 function toggleReadMore() {
   if (checkOverflow(description)) {
     readMoreLink.style.display = "inline-block";
   } else {
     readMoreLink.style.display = "none";
   }
 }
 toggleReadMore();
 function debounce(func, wait = 200) {
   let timeout;
   return function (...args) {
     clearTimeout(timeout);
     timeout = setTimeout(() => func(...args), wait);
   };
 }
 // Keep a reference to the debounced function
 const debouncedResize = debounce(toggleReadMore, 200);
 window.addEventListener("resize", debouncedResize);
 // Cleanup logic (important for SPAs)
 document.addEventListener("beforeunload", () => {
   window.removeEventListener("resize", debouncedResize);
 });
});